// this style is in right a panel, out of the feature scope, so use as the global pattern
/* eslint-disable @typescript-eslint/no-unused-vars */
import { glyphIconStyle } from './glyph-icon-style';
import { convertToLocalStyle } from './utils/convert-style';

export const labelPopupStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.popup--labels': {
    width: 394,
    padding: '17px 28px 20px 24px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
    border: 'none',
    ...convertToLocalStyle(glyphIconStyle({ palette })),
    '& .popup__close': {
      textAlign: 'right',
    },
  },
});
